import type { AwsLbGraphResponseKey } from 'types/api/services/metrics-aws-targets'

/**
 * Aligns with `IntelligentHealthCheckTarget` enum from the control plane. The client needs to
 * duplicate these values such that it understands how to route UX flows and code paths based on
 * the type of IHC that was selected or created.
 */
export enum IntelligentHealthCheckType {
  AWS = 'AWS',
  AZURE = 'AZURE',
  GCP = 'GCP',
  FAILURE_FLAG_PROXIES = 'FAILURE_FLAG_PROXIES'
}

export interface IntelligentHealthCheckTypeOption {
  label: string
  type: IntelligentHealthCheckType
}

export interface IntelligentHealthCheckTypesResponse {
  types: IntelligentHealthCheckTypeOption[]
}

export interface IntelligentHealthCheckMetricsGraphDataPoint {
  num_of_services?: number
  tracking_date: string
  value: number
}

export interface IntelligentHealthCheckMetricsGraph {
  end: string
  num_of_data_points: number
  start: string
  stats_by_date: IntelligentHealthCheckMetricsGraphDataPoint[]
}

export interface IntelligentHealthCheckMetricsQueryOptions {
  endTime?: string | number
  ihcTargetId: string
  startTime?: string | number
  statusCheck?: AwsLbGraphResponseKey
}

export interface IntelligentHealthCheckMetricsQueryKeyParams
  extends IntelligentHealthCheckMetricsQueryOptions {
  teamId: string
}

export interface IntelligentHealthCheckMetricsResponse {
  graphs: {
    [key in AwsLbGraphResponseKey]: IntelligentHealthCheckMetricsGraph
  }
  ihc_target_id: string
}

export type IntelligentHealthCheckTargetIds = string[]
